export const services = [
  {
    id: 'vocational-skills',
    slug: 'vocational-skills',
    title: 'Vocational Skills Training',
    shortDesc: 'Hands-on, competency-based training designed to build real-world job skills that employers demand.',
    icon: 'ri-tools-line',
    treats: ['Trade-specific technical skills', 'Industry certifications', 'Equipment operation & safety', 'Professional standards & protocols', 'Workplace communication'],
    forWho: 'Individuals seeking to enter a skilled trade, gain a vocational certification, or advance their career in a technical field.',
    outcomes: 'Industry-recognized credentials, job-ready competencies, and a clear pathway to sustained employment.',
  },
  {
    id: 'job-readiness',
    slug: 'job-readiness',
    title: 'Job Readiness & Career Development',
    shortDesc: 'Comprehensive preparation for entering or re-entering the workforce — from resume building to interview confidence.',
    icon: 'ri-briefcase-line',
    treats: ['Resume & application building', 'Interview skills & coaching', 'Professional communication', 'Workplace etiquette & behavior', 'Career goal mapping'],
    forWho: 'Job seekers, career changers, and individuals who need structured support to successfully enter or return to the workforce.',
    outcomes: 'Polished professional presence, increased interview success rates, and confident job market entry.',
  },
  {
    id: 'life-skills',
    slug: 'life-skills',
    title: 'Life Skills Development',
    shortDesc: 'Foundational skills training covering financial literacy, communication, and daily life management for lasting independence.',
    icon: 'ri-seedling-line',
    treats: ['Financial literacy & budgeting', 'Time management & organization', 'Communication & interpersonal skills', 'Problem-solving & critical thinking', 'Self-advocacy & goal setting'],
    forWho: 'Individuals seeking greater personal independence, those re-entering society, and anyone building a stronger foundation for life success.',
    outcomes: 'Greater personal independence, self-sufficiency, and the practical tools to manage life and career with confidence.',
  },
  {
    id: 'employment-placement',
    slug: 'employment-placement',
    title: 'Employment Placement Support',
    shortDesc: 'Direct job placement assistance connecting trained individuals with employers who need skilled, reliable workers.',
    icon: 'ri-user-star-line',
    treats: ['Employer partnerships & referrals', 'Job matching & placement coordination', 'Post-placement follow-up', 'Workplace transition coaching', 'Retention support'],
    forWho: 'Program graduates and trained participants ready to transition into employment who need direct employer connections and placement support.',
    outcomes: 'Successful job placement, long-term employment retention, and continued career advancement.',
  },
  {
    id: 'community-reintegration',
    slug: 'community-reintegration',
    title: 'Community Reintegration Programs',
    shortDesc: 'Structured support programs helping individuals rebuild their lives and reconnect with productive community participation.',
    icon: 'ri-community-line',
    treats: ['Re-entry support & planning', 'Community resource navigation', 'Peer support & mentoring', 'Barrier identification & removal', 'Social skills & civic participation'],
    forWho: 'Individuals returning from incarceration, facing housing instability, or navigating major life transitions who need structured community support.',
    outcomes: 'Successful community reintegration, stable employment, and a strengthened network of personal and professional support.',
  },
  {
    id: 'workforce-development',
    slug: 'workforce-development',
    title: 'Workforce Development Training',
    shortDesc: 'Structured workforce programs aligned with regional employer demand to build a pipeline of skilled, work-ready talent.',
    icon: 'ri-bar-chart-grouped-line',
    treats: ['Sector-specific workforce training', 'Employer-aligned curriculum', 'Soft skills & professional readiness', 'Leadership & supervisory skills', 'Compliance & workplace safety'],
    forWho: 'Organizations, nonprofits, and employers seeking to train, upskill, or develop their workforce through structured, outcome-driven programs.',
    outcomes: 'A stronger, more capable workforce with measurable productivity gains and lower turnover.',
  },
];
